module.exports = __webpack_public_path__ + "static/media/flag-china.6b407738.svg";